<template>
    <div
        class="Confirm"
    >
        <div class="row">
            <div class="col col-12">
                <div class="Confirm-icon">
                    <Valid />
                </div>
                <div class="Confirm-title">
                    {{ $t('form-contact.sent.title') }}
                </div>
                <div class="Confirm-subtitle">
                    {{ $t('form-contact.sent.subtitle') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Valid from '@/assets/images/valid.svg';

import Vue from "vue";
import Component from "vue-class-component";

@Component({
    components: {
        Valid
    },
})
export default class Confirm extends Vue {}
</script>

<style lang="scss" scoped>
.Confirm{
    color: #573781;
    text-align: center;
    padding: 8px;

    &-title{
      font-size: 22px;
      font-weight: 800;
      margin-bottom: 12px;
    }

    &-subtitle{
      font-size: 18px;
      font-weight: 400;
    }
    &-icon{
      margin-bottom: 24px;
    }

  }
</style>